{#if $items.length > 0}
    <tm-countdown 
        class="pr-2 pr-sm-3" 
        on:elapsed={elapsed} 
        role="timer" 
        aria-live="off"
        tabindex="-1"
    ></tm-countdown>
{/if}


<script lang="ts">
    import { Shop } from "@ticketmachine/sdk";
    import { _ } from "@frontend/translations";

    const items = Shop.current.cart.items;

    function elapsed() {
        Shop.current.cart.reload().catch(window.reportError);
        alert($_("timer.elapsed"));
    }
</script>

